
const onClickAccordionHeader = (e) => {
  const parentAccordion = e.currentTarget.closest('.accordion');
  const accordionItems = parentAccordion.querySelectorAll('.accordion-item');

  if (e.currentTarget.parentNode.classList.contains('active')) {
    e.currentTarget.parentNode.classList.remove('active');
  } else {
    Array.prototype.forEach.call(accordionItems, (e) => e.classList.remove('active'));
    e.currentTarget.parentNode.classList.add('active');
  }
};

const initAccordion = () => {
  const accordionItem = document.querySelectorAll('.accordion-item');
  Array.prototype.forEach.call(accordionItem, (e) =>
    e.querySelector('.accordion-header').addEventListener('click', onClickAccordionHeader, false)
  );
};

document.addEventListener('DOMContentLoaded', initAccordion);

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.hash === '#scroll-point') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  const viewProductLinks = document.querySelectorAll("a[href='#scroll-point']");
  viewProductLinks.forEach(function (viewProductLink) {
    viewProductLink.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
});
